// StatusField Component
import { memo } from 'react';
import { CircularProgress, Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import { GenericSearchItem } from '../../SearchItemsProvider';

// Wire Search Item
type SyndicationStatusFieldProps = {
  record: GenericSearchItem;
};

const SyndicationStatusField = memo(({ record }: SyndicationStatusFieldProps) => {
  if (record.status === 'importing') {
    return (
      <CircularProgress
        data-testid="importing-icon"
        size={14}
      />
    );
  }

  if (record.status === 'imported') {
    return (
      <Tooltip title="Imported">
        <CheckCircleIcon
          data-testid="imported-status-icon"
          sx={(theme) => ({
            color: theme.palette.success.main,
            fontSize: theme.typography.body2.fontSize,
            fontWeight: theme.typography.fontWeightMedium,
          })}
        />
      </Tooltip>
    );
  }

  if (record.status === 'imported-update') {
    return (
      <Tooltip title="Update Available">
        <RefreshIcon
          data-testid="imported-update-icon"
          sx={(theme) => ({
            color: theme.palette.primary.main,
            fontSize: theme.typography.body2.fontSize,
            fontWeight: theme.typography.fontWeightMedium,
          })}
        />
      </Tooltip>
    );
  }

  return null; // Return null if no conditions are met
});

SyndicationStatusField.displayName = 'SyndicationStatusField';
export default SyndicationStatusField;
